import {ajax,getRequestUrl,formatData} from "../request";


export default {
  // 广告查询--广告信息查询列表
  findAdvertiseList(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/findAdvertiseList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 广告查询--上下架广告
  advertiseIsOn(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/advertiseIsOn'), data, {
      method,
    })
  },

  // 广告查询--删除广告
  advertiseDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/advertiseDelete'), data, {
      method,
    })
  },

  // 广告查询--广告详情
  advertiseInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/advertiseInfo'), data, {
      method,
    })
  },

  // 广告查询--保存广告信息
  advertiseSave(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/advertiseSave'), data, {
      method,
    })
  },

  // 广告查询--运营弹窗
  popListByPaged(data, method) {
    return ajax('post', getRequestUrl('/banner/loginPopWindow/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 广告查询--运营弹窗--保存弹窗数据
  popListBySaved(data, method) {
    return ajax('post', getRequestUrl('/banner/loginPopWindow/save'), data, {
      method,
    })
  },

  // 广告查询--运营弹窗--弹窗数据详情
  popListByInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/popInfo'), data, {
      method,
    })
  },

  // 广告查询--运营弹窗--删除弹窗数据
  popListByDelete(data, method) {
    return ajax('post', getRequestUrl('/banner/loginPopWindow/delete'), data, {
      method,
    })
  },

  // 广告查询--开屏弹窗--弹窗列表
  openScreenPopupList(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/openScreenPopupList'), data, {
      method,
    })
  },

  // 广告查询--开屏弹窗--弹窗保存
  openScreenPopupSave(data, method) {
    return ajax('post', getRequestUrl('/api/Advertise/openScreenPopupSave'), data, {
      method,
    })
  },

  // 加载页背景列表
  loadingPageList(data, method) {
    return ajax('post', getRequestUrl('/banner/loadingPage/list'), data, {
      method,
    })
  },
  // 加载页背景添加、修改
  loadingPageSave(data, method) {
    return ajax('post', getRequestUrl('/banner/loadingPage/save'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/ad.js